export const defaultvalues = {
  MCC: 315,
  MNC: "010",
  TAC: 63,
};

export const UNDER_MAINTENANCE = "UNDER_MAINTENANCE";

export const HARDWARE_MODEL_TYPES = {
  Indoor: "Indoor",
  Flex: "Flex",
  Outdoor: "Outdoor",
};
export enum OBJ_STATUS {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  NA = "NA",
  ASSIGNED = "ASSIGNED",
  UNASSIGNING = "UNASSIGNING",
  MARK_UNASSIGNED = "MARK_UNASSIGNED",
  UNASSIGNED = "UNASSIGNED",
  USED = "USED",
  NOT_DEPLOYED = "NOT_DEPLOYED",
  DEPLOYING = "DEPLOYING",
  DEPLOYED = "DEPLOYED",
  FAILED = "FAILED",
  DELETING = "DELETING",
  IN_PROGRESS = "IN_PROGRESS",
  MARKED_FOR_REVOKE = "MARKED_FOR_REVOKE",
  MARKED_FOR_DELETE="MARKED_FOR_DELETE",
  REVOKING="REVOKING",
  REVOKED="REVOKED",

  MARKED_FOR_UPGRADE = "MARKED_FOR_UPGRADE",
  MARKED_FOR_RETRY = "MARKED_FOR_RETRY",
  MARKED_FOR_UPDATE = "MARKED_FOR_UPDATE",

  UPGRADING = "UPGRADING",
  UPDATING = "UPDATING",
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  DELETE_FAILED = "DELETE_FAILED",
  UPGRADE_FAILED = "UPGRADE_FAILED",
  UPDATE_FAILED = "UPDATE_FAILED",
}

export const REVOKE = "REVOKE";

export const Types = {
  hardware : "hardware",
  radio : "radio",
} as const;


export const MAP_KEY = import.meta.env.H9_GOOGLE_MAP_API_KEY as string;

// Mobile App Login Constants
export const MOBILE_APP_LOGIN = {
  URL_TYPE: "mobileApp",
  DEEP_LINK_SCHEME: "highway9://login",
  LOGIN_METHOD: {
    DEEP_LINK: "deeplink",
    WEBVIEW: "webview",
  },
  SESSION_STORAGE_KEYS: {
    REDIRECT_PAGE: "redirectPage",
    LOGIN_METHOD: "loginMethod",
  },
  /**
   * Marks the login route as belonging to a mobile-app sign-in (MCS-4722). sessionStorage
   * alone cannot carry that across the OIDC round trip, because the identity provider can
   * finish the flow in a different tab or browser, which starts with an empty store. This
   * travels in the redirect URI instead, which the OIDC state hands back either way.
   */
  QUERY_PARAM: "mobileApp",
} as const;